module.exports = __webpack_public_path__ + "img/sx.85d98814.svg";